import { CalendarMonthOutlined } from '@lichtblick/icons';
import { TextVariants } from '@lichtblick/theme';
import { formatDateTime2Digit, isSameDay, formatTime } from '@lichtblick/utils';

import { Container, ItemWrapper, StatusDot, StatusDotWrapper } from './Appointment.styles';
import { getIcon } from './utils';

import { Text } from '../Text';

type AppointmentProps = {
  endDate?: string;
  isBinding?: boolean;
  startDate?: string;
  variant: string;
};

export const Appointment = ({ endDate, isBinding, startDate, variant }: AppointmentProps) => {
  return (
    <Container $isBinding={isBinding ?? false} $variant={variant}>
      <StatusDotWrapper>
        <ItemWrapper>
          {getIcon(variant)}
          <Text $variant={TextVariants.body.m}>{variant}</Text>
        </ItemWrapper>
        <StatusDot $isBinding={isBinding ?? false} />
      </StatusDotWrapper>
      <ItemWrapper>
        <CalendarMonthOutlined />
        <Text $variant={TextVariants.body.m}>
          {startDate && endDate && !isSameDay(startDate, endDate)
            ? `${formatDateTime2Digit(startDate)} - ${formatDateTime2Digit(endDate)}`
            : `${formatDateTime2Digit(startDate)} ${formatTime(startDate)}`}
        </Text>
      </ItemWrapper>
    </Container>
  );
};
